import { Link } from 'react-router-dom';
import { publicRegistry } from '@/i18n/dictionaries/publicRegistry';
import { useTranslation } from '@/i18n/useTranslation';
import type { AdvisorsEmptyMessageProps } from '@/features/publicsite/types/registry/AdvisorsEmptyMessageProps';

/**
 * What an empty registry says — and, after a search or a domain filter, the way back to the whole
 * list. `filtered` rather than the search text: a domain that matches nobody empties the page just
 * as a search does, and reading only the search would have told that visitor the registry itself
 * was empty.
 */
export function AdvisorsEmptyMessage({ filtered }: AdvisorsEmptyMessageProps) {
  const { t } = useTranslation(publicRegistry);
  return (
    <>
      <p className="empty-state__title">
        {filtered ? t('advisorsEmptyFiltered') : t('advisorsEmptyAll')}
      </p>
      {filtered && (
        <p className="empty-state__hint">
          {t('advisorsEmptyHintBefore')} <Link to="/consilieri">{t('advisorsEmptyHintLink')}</Link>.
        </p>
      )}
    </>
  );
}
